/**
 * 読み込み中の表示（03 3.2.1：画面の遅延読み込みの間は骨組みを出す）。
 */
import { Box, CircularProgress, Skeleton } from '@mui/material';
import { FE_MESSAGES } from '@pcrm/shared';

export function PageLoading() {
  return (
    <Box role="status" aria-label={FE_MESSAGES['FE-MSG-I-014'].text} data-testid="pcrm-page-loading" sx={{ p: 3 }}>
      <Skeleton variant="text" width={240} height={36} />
      <Skeleton variant="rectangular" height={120} sx={{ mt: 2 }} />
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <CircularProgress size={24} />
      </Box>
    </Box>
  );
}
